import React from "react";

export const INVICTAX_URL = "https://www.invictaflow.ch";

export function PoweredByInvictaX({ variant = "short", className = "" }) {
  const text =
    variant === "full"
      ? "Softwareplattform und digitale Infrastruktur entwickelt, betrieben und lizenziert durch"
      : "Powered by";
  return (
    <p className={`text-xs text-slate-400 ${className}`} data-testid="powered-by-invictax">
      {text}{" "}
      <a
        href={INVICTAX_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-slate-500 hover:text-slate-700 underline-offset-2 hover:underline"
        data-testid="invictax-link"
      >
        InvictaX Group GmbH
      </a>
    </p>
  );
}
